export default __webpack_public_path__ + "static/media/team.17142c73.svg";